var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5H22.5L25.5 7.5H31.5C32.3284 7.5 33 8.17158 33 9V30C33 30.8284 32.3284 31.5 31.5 31.5H4.5C3.67158 31.5 3 30.8284 3 30V9C3 8.17158 3.67158 7.5 4.5 7.5H10.5L13.5 4.5ZM18 28.5C22.9706 28.5 27 24.4706 27 19.5C27 14.5294 22.9706 10.5 18 10.5C13.0294 10.5 9 14.5294 9 19.5C9 24.4706 13.0294 28.5 18 28.5ZM18 25.5C14.6863 25.5 12 22.8137 12 19.5C12 16.1863 14.6863 13.5 18 13.5C21.3137 13.5 24 16.1863 24 19.5C24 22.8137 21.3137 25.5 18 25.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.a0cd8282b48bd9c616f936fa763850f8.svg";
export { ForwardRef as ReactComponent };